import { ActionItemWrapper } from '@anm/components/ActionsDropdown';
import { Item } from '@anm/components/ActionsDropdown/ActionItem';
import { FC } from 'react';
import styled from 'styled-components';

import DuplicateUpgradeTooltip, { DuplicateUpgradeTooltipProps } from '../DuplicateUpgradeTooltip';
import Tooltip from '../../../Tooltip';
import { notStableTooltip } from '../../NotStableTooltip';
import { ActionTooltip, ActionTooltipWrapper } from '../../streamVideo/Wrapper';

const Wrapper = styled(ActionItemWrapper)`
  && > a,
  && span {
    padding-left: 48px !important;
  }
`;

type DuplicateActionProps = DuplicateUpgradeTooltipProps & {
  isNotStable?: boolean;
  shouldUpgrade: boolean;
};

const DuplicateAction: FC<DuplicateActionProps> = ({ action, handler, shouldUpgrade, isNotStable }) => (
  <Wrapper as="div" {...action} onClick={shouldUpgrade ? undefined : handler}>
    {shouldUpgrade ? (
      <DuplicateUpgradeTooltip {...{ action }} />
    ) : (
      <ActionTooltipWrapper>
        <Tooltip renderContent={isNotStable ? () => <ActionTooltip>{notStableTooltip()}</ActionTooltip> : undefined}>
          <Item {...action} />
        </Tooltip>
      </ActionTooltipWrapper>
    )}
  </Wrapper>
);

export default DuplicateAction;
